export const Integrations = () => {
    return (<>Integrations</>);
}